import { useEffect } from 'react';
import useModalStore, {
  ModalNames,
} from 'features/multi-porto/stores/modal.store';

import useSubAccounts from 'features/multi-porto/hooks/useSubAccounts';
import CreateOnboarding from '../Modal/Create/CreateOnboarding';
import CreatePorto from '../Modal/Create/CreatePorto';
import CreateRenamePorto from '../Modal/Create/CreateRenamePorto';
import CreateTnc from '../Modal/Create/CreateTnc';
import CreateSuccess from '../Modal/Create/CreateSuccess';
import CreateError from '../Modal/Create/CreateError';

import TransferSelect from '../Modal/Transfer/TransferSelect';

import TransferCash from '../Modal/Transfer/TransferCash';
import TransferCashConfirm from '../Modal/Transfer/TransferCashConfirm';
import TransferCashSuccess from '../Modal/Transfer/TransferCashSuccess';
import TransferCashBalanceReview from '../Modal/Transfer/TransferCashBalanceReview';

import TransferStock from '../Modal/Transfer/TransferStock';
import TransferStockConfirm from '../Modal/Transfer/TransferStockConfirm';
import TransferStockSuccess from '../Modal/Transfer/TransferStockSuccess';

export default function MultiPortoModalManager() {
  const modal = useModalStore((s) => s.activeModal);
  const setModal = useModalStore((s) => s.openModal);
  const closeModal = useModalStore((s) => s.closeModal);
  const { getSubAccounts } = useSubAccounts();

  const onCreatePortfolio = async () => {
    closeModal();

    try {
      const data = await getSubAccounts();

      const { can_create_new_sub_account: canCreatePortfolio } = data;

      if (!canCreatePortfolio) {
        setModal(ModalNames.PORTFOLIO_CREATE_BLOCKED);
        return;
      }

      setModal(ModalNames.PORTFOLIO_CREATE);
    } catch (error) {
      console.error('Error on onCreatePortfolio', error);
    }
  };

  useEffect(() => {
    if (modal) {
      document.body.classList.add('modal-multi-porto-open');
    } else {
      document.body.classList.remove('modal-multi-porto-open');
    }

    return () => {
      document.body.classList.remove('modal-multi-porto-open');
    };
  }, [modal]);

  return (
    <>
      <CreateOnboarding
        visible={modal === ModalNames.PORTFOLIO_ONBOARDING}
        onCancel={closeModal}
        onSubmit={onCreatePortfolio}
      />

      <CreatePorto
        visible={modal === ModalNames.PORTFOLIO_CREATE}
        onCancel={closeModal}
        onSubmit={() => {
          closeModal();
          setModal(ModalNames.PORTFOLIO_TNC);
        }}
      />

      <CreateRenamePorto
        visible={modal === ModalNames.PORTFOLIO_RENAME}
        onCancel={closeModal}
        onSubmit={closeModal}
      />

      <CreateTnc
        visible={modal === ModalNames.PORTFOLIO_TNC}
        onCancel={closeModal}
        onSubmit={() => {
          closeModal();
          setModal(ModalNames.PORTFOLIO_SUCCESS);
        }}
      />

      <CreateSuccess
        visible={modal === ModalNames.PORTFOLIO_SUCCESS}
        onCancel={closeModal}
        onSubmit={() => {
          closeModal();
        }}
      />

      <CreateError
        visible={modal === ModalNames.PORTFOLIO_CREATE_BLOCKED}
        onCancel={closeModal}
        onSubmit={closeModal}
      />

      <TransferSelect
        visible={modal === ModalNames.TRANSFER_SELECT}
        onCancel={closeModal}
        onSubmit={closeModal}
      />

      <TransferCash
        visible={modal === ModalNames.TRANSFER_CASH}
        onCancel={closeModal}
        onSubmit={() => {
          closeModal();
          setModal(ModalNames.TRANSFER_CASH_CONFIRM);
        }}
      />

      <TransferCashConfirm
        visible={modal === ModalNames.TRANSFER_CASH_CONFIRM}
        onCancel={closeModal}
        onSubmit={() => {
          closeModal();
          setModal(ModalNames.TRANSFER_CASH_SUCCESS);
        }}
        onBack={() => {
          closeModal();
          setModal(ModalNames.TRANSFER_CASH);
        }}
      />

      <TransferCashSuccess
        visible={modal === ModalNames.TRANSFER_CASH_SUCCESS}
        onCancel={closeModal}
        onSubmit={closeModal}
      />

      <TransferCashBalanceReview
        visible={modal === ModalNames.TRANSFER_CASH_BALANCE_REVIEW}
        onCancel={closeModal}
        onSubmit={closeModal}
        onBack={() => {
          closeModal();
          setModal(ModalNames.TRANSFER_CASH);
        }}
      />

      <TransferStock
        visible={modal === ModalNames.TRANSFER_STOCK}
        onCancel={closeModal}
        onSubmit={() => {
          closeModal();
          setModal(ModalNames.TRANSFER_STOCK_CONFIRM);
        }}
      />

      <TransferStockConfirm
        visible={modal === ModalNames.TRANSFER_STOCK_CONFIRM}
        onCancel={closeModal}
        onSubmit={() => {
          closeModal();
          setModal(ModalNames.TRANSFER_STOCK_SUCCESS);
        }}
      />

      <TransferStockSuccess
        visible={modal === ModalNames.TRANSFER_STOCK_SUCCESS}
        onCancel={closeModal}
        onSubmit={closeModal}
      />
    </>
  );
}
